
import { SidebarActions, SidbarActionTypes } from "./siderbar.actions";
import { TipActions, TipActionTypes } from "./tip.actions";

export * from "./siderbar.actions";
export * from "./tip.actions";

export const ActionTypes = {
    ...SidbarActionTypes,
    ...TipActionTypes,    
};

export type Actions = SidebarActions | TipActions;

